export class User {
  // todo merge with Vermowgensberater Model
  userid: string;
  email: string;
  name: string;
  anrede?: string;
  vorname: string;
}
